import React from "react";
import { Tooltip } from "antd";

import CrownNone from "../assets/images/crown_none.png";
import SilverCrown from "../assets/images/silver_crown.png";
import GoldCrown from "../assets/images/gold_crown.png";
import DonderfulCrown from "../assets/images/donderful_crown.png";

const Crown = ({ crown }) => {
    const crownStyles = {
        width: "25x",
        height: "25px",
    };

    const renderCrown = (crown) => {
        switch (crown) {
            case 0:
                return (
                    <Tooltip title="Failed">
                        <img src={CrownNone} alt="Failed" style={crownStyles} />
                    </Tooltip>
                );
            case 1:
                return (
                    <Tooltip title="Cleared">
                        <img
                            src={SilverCrown}
                            alt="Silver Crown"
                            style={crownStyles}
                        />
                    </Tooltip>
                );
            case 2:
                return (
                    <Tooltip title="Full Combo">
                        <img
                            src={GoldCrown}
                            alt="Gold Crown"
                            style={crownStyles}
                        />
                    </Tooltip>
                );
            case 3:
                return (
                    <Tooltip title="Donderful Combo">
                        <img
                            src={DonderfulCrown}
                            alt="Donderful Crown"
                            style={crownStyles}
                        />
                    </Tooltip>
                );
            default:
                return null;
        }
    };

    return renderCrown(crown);
};

export default Crown;
